import axios from 'axios'
import md5 from 'js-md5'

axios.interceptors.response.use(
    response => {
        const { code } = response.data || {}
        if (code === 401 || code === '401' || code === '100004') {
            localStorage.removeItem('user')
            localStorage.removeItem('userId')
            localStorage.removeItem('uuid')
            localStorage.removeItem('token')
            localStorage.removeItem('isVisible')
            window.location.href = '/login'
            return Promise.reject(new Error('登录已过期'))
        }
        return response
    },
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('user')
            localStorage.removeItem('userId')
            localStorage.removeItem('uuid')
            localStorage.removeItem('token')
            localStorage.removeItem('isVisible')
            window.location.href = '/login'
        }
        return Promise.reject(error)
    }
)


export const config = {
  ApiKey: '38a5d3f2020b0fae2f01065550d26ba7',
  //  baseUrl: 'http://kylinos-test.fansutech.com/api/'
  // baseUrl: 'http://test-qilin.bjfxtx.cn/api/'
  // baseUrl: 'http://10.44.17.103:5010/api/'
  baseUrl: process.env.VUE_APP_API_BASE || '/api/',
  //baseUrl: 'https://x2kylin.kylinos.cn/api/'
    //新的线上环境地址
  // baseUrl: 'https://product.kylinos.cn/api/'
}

export const post = (url, data) => {
  let token = localStorage.getItem('token')||''
  // 处理header信息
  var header = {}
  if (!isJSON(data)) {
	// let timestamp = getQueryVariable(data, 'Fx-Timestamp');
	// let sign = getQueryVariable(data, 'sign');
	let timeSign = new Date().getTime();
	let str = 'Fx-Timestamp' + '=' + timeSign + config.ApiKey
	let Sign = md5(str)
	data = removeSign(data);
    header = {
		'Fx-Timestamp': timeSign,
		'Fx-Sign': Sign,
		'Content-Type': 'application/x-www-form-urlencoded',
		'token': token
	}
  } else {
    //ajaxParam(data)
	var timeSign = new Date().getTime();
    var str = 'Fx-Timestamp' + '=' + timeSign + config.ApiKey
    var Sign = md5(str)
    header = {
      'Fx-Timestamp': timeSign,
      'Fx-Sign': Sign,
      'Content-Type': 'application/json;charset=UTF-8',
        'token': token
    }

    //data.time = new Date().getTime()
    //data['Fx-Sign'] = Sign
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      baseURL: config.baseUrl,
      headers: header

    }).then((res) => {
      resolve(res)
    }, err => {
      reject(err)
    })
  })
}
export const get = (url, data) => {
    let token = localStorage.getItem('token')||''
    // 处理header信息
    var header = {}
    if (!isJSON(data)) {
        // let timestamp = getQueryVariable(data, 'Fx-Timestamp');
        // let sign = getQueryVariable(data, 'sign');
        let timeSign = new Date().getTime();
        let str = 'Fx-Timestamp' + '=' + timeSign + config.ApiKey
        let Sign = md5(str)
        data = removeSign(data);
        header = {
            'Fx-Timestamp': timeSign,
            'Fx-Sign': Sign,
            'Content-Type': 'application/x-www-form-urlencoded',
            'token': token
        }
    } else {
        //ajaxParam(data)
        var timeSign = new Date().getTime();
        var str = 'Fx-Timestamp' + '=' + timeSign + config.ApiKey
        var Sign = md5(str)
        header = {
            'Fx-Timestamp': timeSign,
            'Fx-Sign': Sign,
            'Content-Type': 'application/json;charset=UTF-8',
            'token': token
        }
    }
    return new Promise((resolve, reject) => {
        axios.get(url,  {
            baseURL: config.baseUrl,
            headers: header,
            params: data
        }).then((res) => {
            resolve(res)
        }, err => {
            reject(err)
        })
    })
}
export const ajaxParam = (param) => {
  param['Fx-Timestamp'] = new Date().getTime()
  var paramStr = ''
  var keys = []
  // 参数名排序
  for (var key in param) {
    keys.push(key)
  }
  keys.sort()
  for (var index in keys) {
    var key2 = keys[index]
    var str = param[key2]
    console.log(str,'strstrstrstrstr')
    if (str !== null&&str !== undefined && str.length !== 0) {
      if (paramStr.length === 0) {
        paramStr = (key2 + '=' + str)
      } else {
        paramStr = paramStr + '&' + (key2 + '=' + str)
      }
    } else {
      delete param[key2]
    }
  }
  if (paramStr.length === 0) {
    paramStr = config.ApiKey
  } else {
    paramStr = paramStr + config.ApiKey
  }
  param.sign = md5(paramStr)
}
export const formatTime = (date) => {
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()

  var hour = date.getHours()
  var minute = date.getMinutes()
  var second = date.getSeconds()
  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
export const formatTimeDate = (date) => {
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  return [year, month, day].map(formatNumber).join('-')
}
function formatNumber (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}
function isJSON(obj){
    var isjson = typeof(obj) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length;
    return isjson;
}

// function getQueryVariable(data,variable){
// 	var vars = data.split("&");
// 	for (var i=0; i<vars.length; i++) {
// 		var pair = vars[i].split("=");
// 		if(pair[0] == variable) {
// 			return pair[1];
// 		}
// 	}
// 	return(false);
// }
function removeSign(data){
	let returnData = '';
	var vars = data.split("&");
	for (var i=0; i<vars.length; i++) {
		var pair = vars[i].split("=");
		if(pair[0] !== 'Fx-Timestamp' && pair[0] !== 'sign') {
			returnData += vars[i] + "&";
		}
	}
	if(returnData.indexOf('&') > -1){
		returnData = returnData.substring(0,returnData.length-1)
	}
	return returnData;
}
